<a [routerLink]="routerLink">
  {{ label }}
  @if (isIconVisible) {
    <shared-icon icon="arrow-right" width="0.5rem" height="0.5rem" />
  }
</a>
